// extracted by mini-css-extract-plugin
export var addButton = "_d1-4";
export var contentBlockImage = "_d1-i";
export var contentBlockWidgetPreview = "_d1-g";
export var fulfillmentCutoffWidgetPreview = "_d1-9";
export var imageBackdrop = "_d1-6";
export var imageIcon = "_d1-8";
export var lowProfileImageContainer = "_d1-b";
export var lowProfileImageIcon = "_d1-f";
export var lowProfileImageIconContainer = "_d1-e";
export var lowProfileImagePlaceholder = "_d1-d";
export var lowProfileProductImage = "_d1-c";
export var lowProfileProductUpsellWidgetPreview = "_d1-a";
export var productCard = "_d1-5";
export var productImage = "_d1-7";
export var productReviewsWidgetPreview = "_d1-h";
export var progressBar = "_d1-1";
export var progressBarFill = "_d1-2";
export var progressBarTrack = "_d1-3";
export var shippingOptionWidgetPreview = "_d1-j";
export var shippingUpsellProgressBar = "_d1-k";
export var thresholdUpsellWidgetPreview = "_d1-0";